import {
  scalarButton,
  scalarCallout,
  scalarCard,
  scalarRow,
  scalarFlex,
  scalarMath,
  scalarEmbed,
  scalarCodeBlock,
  scalarImage,
  scalarTabs,
  scalarTab,
  scalarSteps,
  scalarStep,
  scalarDetail,
  scalarIcon,
  scalarPageLink,
  scalarPageTitle,
  scalarHeading
} from "@scalar-org/guide-elements/elements";
const customElements = {
  [scalarButton.name]: scalarButton,
  [scalarCallout.name]: scalarCallout,
  [scalarCard.name]: scalarCard,
  [scalarRow.name]: scalarRow,
  [scalarEmbed.name]: scalarEmbed,
  [scalarIcon.name]: scalarIcon,
  [scalarMath.name]: scalarMath,
  [scalarFlex.name]: scalarFlex,
  [scalarCodeBlock.name]: scalarCodeBlock,
  [scalarHeading.name]: scalarHeading,
  [scalarImage.name]: scalarImage,
  [scalarPageTitle.name]: scalarPageTitle,
  [scalarTab.name]: scalarTab,
  [scalarTabs.name]: scalarTabs,
  [scalarSteps.name]: scalarSteps,
  [scalarStep.name]: scalarStep,
  [scalarDetail.name]: scalarDetail,
  [scalarPageLink.name]: scalarPageLink
};
const customComponentTags = Object.keys(
  customElements
);
const hydrateAll = (options) => {
  const hydrationFunctions = Object.values(customElements).map((el) => el.hydrate).filter((fn) => typeof fn === "function");
  return hydrationFunctions.reduce(
    (allSucceeded, fn) => fn(options) && allSucceeded,
    true
  );
};
export {
  customComponentTags,
  customElements,
  hydrateAll
};
//# sourceMappingURL=index.js.map
